import React, { useState, useCallback } from 'react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import PropTypes from 'prop-types';
import { HoverCard, DirectionalHint, Text, HoverCardType } from '@fluentui/react';

const GoalTypeDropdownOptionUnstyled = (props) => {
  const [contentRendered, setContentRendered] = useState(false);

  const { option: { text, calloutOption }, classes } = props;
  const renderCallout = useCallback(() => (
    <div className={classes.goalTypeCallout}>
      <div className={classes.header}>
        <Text className={classes.title}>
          {calloutOption.title}
        </Text>
      </div>
      <div className={classes.inner}>
        <Text>{calloutOption.description}</Text>
      </div>
    </div>), [classes, calloutOption]);
  const plainCardProps = {
    directionalHint: DirectionalHint.rightCenter,
    onRenderPlainCard: renderCallout,
    renderData: calloutOption,
    gapSpace: 16,
    calloutProps: {
      isBeakVisible: true,
    },
  };
  React.useEffect(() => setContentRendered(true), []);

  const targetElementRef = React.useRef();
  return (
    <div className={classes.goalTypeOption} ref={targetElementRef} data-is-focusable >
      <span className={classes.goalTypeText}>{text}</span>
      {calloutOption && contentRendered &&
        <HoverCard plainCardProps={plainCardProps} type={HoverCardType.plain} directionalHintFixed target={targetElementRef.current} cardOpenDelay={100} />
      }
    </div>
  );
};

GoalTypeDropdownOptionUnstyled.propTypes = {
  option: PropTypes.shape({
    text: PropTypes.string.isRequired,
    description: PropTypes.string,
  }).isRequired,
  classes: PropTypes.shape({}).isRequired,
};

export const GoalTypeDropdownOption = withDefaultStyles(GoalTypeDropdownOptionUnstyled, () => ({
  goalTypeOption: { width: '100%', height: '100%' },
  goalTypeText: { paddingLeft: '16px', paddingRight: '16px' },
  goalTypeCallout: { minWidth: '300px', minHeight: '100px' },
  title: {
    fontWeight: 600,
    display: 'inline-block',
    fontSize: 14,
    margin: 0,
  },
  header: {
    padding: '18px 24px 12px',
  },
  inner: {
    height: '100%',
    padding: '0 24px 20px',
  },
}));
